import React from "react";
import OpenComponentDialog from "src/components/shared-components/modal/openComponentModal";
import StockAddLayout from "./components/StockAddLayout";

interface AddStockModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  upn?: string;
}

// Stok Ekle modalı - Hizmet Ekle modal tasarımı ile aynı layout kullanır
const AddStockModal: React.FC<AddStockModalProps> = ({
  open,
  onClose,
  title,
  description,
  upn,
}) => {
  return (
    <OpenComponentDialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      hideHeader={true}
      showPatientData={false}
    >
      <StockAddLayout
        title={title}
        fileProtocol={upn || description}
        onClose={onClose}
      />
    </OpenComponentDialog>
  );
};

export default AddStockModal;


